module.exports = {
          srcSet: __webpack_public_path__ + "57450df1.jpg"+" 700w"+","+__webpack_public_path__ + "651d41b1.jpg"+" 1105w",
          images:[ {path: __webpack_public_path__ + "57450df1.jpg",width: 700,height: 523},{path: __webpack_public_path__ + "651d41b1.jpg",width: 1105,height: 826}],
          src: __webpack_public_path__ + "57450df1.jpg",
          toString:function(){return __webpack_public_path__ + "57450df1.jpg"},
          
          width: 700,
          height: 523
        }